/* tslint:disable */
// tslint:disable-object-literal-sort-keys
const t = [
  {
    id: 180,
    name: "Adelaide Bank",
    swift_code: "BENDAU3B",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 197,
    name: "Adelaide Bank (division of Bendigo and Adelaide Bank)",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 24,
    name: "AFFIN BANK BERHAD",
    swift_code: "PHBMMYKL",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 80,
    name: "AFFIN BANK BHD",
    swift_code: "PHBMMYKLXXX",
    is_deleted: false,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 260,
    name: "Agricultural Bank Of China, The",
    swift_code: "ABOCCNBJ090",
    is_deleted: false,
    country_id: 47,
    display_name: "Agricultural Bank Of China, The - ABOCCNBJ",
    is_internal_bank: true
  },
  {
    id: 91,
    name: "AGROBANK (AGRO)",
    swift_code: "AGOBMYKLXXX",
    is_deleted: false,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 109,
    name: "AGROBANK - SPI (IAGR)",
    swift_code: "AGOBMYKLXXX",
    is_deleted: false,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 25,
    name: "AIA BHD.",
    swift_code: "AIACMYKL",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 27,
    name: "ALKHAIR INTERNATIONAL ISLAMIC BANK BERHAD",
    swift_code: "UIIBMYKL",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 28,
    name: "ALLIANCE BANK MALAYSIA BERHAD",
    swift_code: "MFBBMYKL",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 82,
    name: "ALLIANCE BANK MALAYSIA BHD",
    swift_code: "MFBBMYKLXXX",
    is_deleted: false,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 81,
    name: "AL RAJHI BANK",
    swift_code: "RJHIMYKLXXX",
    is_deleted: false,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 26,
    name: "AL RAJHI BANKING AND INVESTMENT CORPORATION (MALAYSIA) BHD",
    swift_code: "RJHIMYKL",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 83,
    name: "AMBANK BERHAD",
    swift_code: "ARBKMYKLXXX",
    is_deleted: false,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 29,
    name: "AMBANK (M) BERHAD",
    swift_code: "ARBKMYKL",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 30,
    name: "AMINVESTMENT BANK BERHAD (FORMERLY KNOWN AS AMMERCHANT BANK BERHAD)",
    swift_code: "AMMBMYKL",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 31,
    name: "AMISLAMIC BANK BERHAD",
    swift_code: "AISLMYKL",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 156,
    name: "AMP Bank",
    swift_code: "AMPBAU2SRET",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 251,
    name: "ANEXT BANK PTE. LTD.",
    swift_code: "ANTPSGSGXXX",
    is_deleted: false,
    country_id: 1,
    display_name: "ANEXT BANK PTE. LTD. - ANTPSGSG",
    is_internal_bank: null
  },
  {
    id: 3,
    name: "ANZ",
    swift_code: "ANZBSGSXXXX",
    is_deleted: true,
    country_id: 1,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 245,
    name: "ANZ Bank",
    swift_code: "ANZBSGSXXXX",
    is_deleted: false,
    country_id: 1,
    display_name: "ANZ BANK - ANZBSGSX",
    is_internal_bank: null
  },
  {
    id: 231,
    name: "Arab Bank Australia",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 32,
    name: "ASIAN FINANCE BANK BERHAD",
    swift_code: "AFBQMYKL",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 151,
    name: "Australia and New Zealand Banking Group",
    swift_code: "ANZBAU3M",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 250,
    name: "Australia and New Zealand Banking Group Limited",
    swift_code: "ANZBHKHXXXX",
    is_deleted: false,
    country_id: 3,
    display_name:
      "Australia and New Zealand Banking Group Limited (152) - ANZBHKHX",
    is_internal_bank: null
  },
  {
    id: 205,
    name: "Australian Military Bank",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 196,
    name: "Australian Settlements",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 229,
    name: "Australia Post",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 206,
    name: "Auswide Bank",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 264,
    name: "AXIS BANK LIMITED",
    swift_code: "AXISINBB328",
    is_deleted: false,
    country_id: 97,
    display_name: "AXIS BANK LIMITED - AXISINBB328",
    is_internal_bank: true
  },
  {
    id: 195,
    name: "Bananacoast Community Credit Union",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 84,
    name: "BANGKOK BANK BERHAD",
    swift_code: "BKKBMYKLXXX",
    is_deleted: false,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 33,
    name: "BANGKOK BANK BERHAD",
    swift_code: "BKKBMYKL",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 34,
    name: "BANK AL HABIB LIMITED",
    swift_code: "BAHLMY2A",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 165,
    name: "Bank Australia",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 85,
    name: "BANK ISLAM BHD",
    swift_code: "BIMBMYKLXXX",
    is_deleted: false,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 86,
    name: "BANK KERJASAMA RAKYAT MALAYSIA",
    swift_code: "BKRMMYKLXXX",
    is_deleted: false,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 87,
    name: "BANK MUAMALAT MALAYSIA BERHAD",
    swift_code: "BMMBMYKLXXX",
    is_deleted: false,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 23,
    name: "BANK NEGARA MALAYSIA",
    swift_code: "BNMAMY2K",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 21,
    name: "Bank of America",
    swift_code: "BOFASG2XXXX",
    is_deleted: false,
    country_id: 1,
    display_name: "BANK OF AMERICAN - BOFASG2X",
    is_internal_bank: true
  },
  {
    id: 269,
    name: "BANK OF AMERICA",
    swift_code: "BOFAUS3NXXX",
    is_deleted: false,
    country_id: 229,
    display_name: "BANK OF AMERICA - BOFAUS3N",
    is_internal_bank: true
  },
  {
    id: 88,
    name: "BANK OF AMERICA BHD",
    swift_code: "BOFAMY2XXXX",
    is_deleted: false,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 254,
    name: "Bank of America, National Association",
    swift_code: "BOFAHKHXXXX",
    is_deleted: false,
    country_id: 3,
    display_name: "Bank of America, National Association (055) - BOFAHKHX",
    is_internal_bank: null
  },
  {
    id: 272,
    name: "BANK OF AMERICA SYDNEY",
    swift_code: "BOFAAUSXXXX",
    is_deleted: false,
    country_id: 16,
    display_name: "BANK OF AMERICA SYDNEY - BOFAAUSX",
    is_internal_bank: true
  },
  {
    id: 6,
    name: "Bank of China",
    swift_code: "BKCHSGSGXXX",
    is_deleted: false,
    country_id: 1,
    display_name: "BANK OF CHINA - BKCHSGSG",
    is_internal_bank: null
  },
  {
    id: 265,
    name: "BANK OF CHINA",
    swift_code: "BKCHCNBJ680",
    is_deleted: false,
    country_id: 47,
    display_name: "BANK OF CHINA - BKCHCNBJ680",
    is_internal_bank: true
  },
  {
    id: 275,
    name: "BANK OF CHINA",
    swift_code: "BKCHCNBJ92A",
    is_deleted: false,
    country_id: 47,
    display_name: "BANK OF CHINA - BKCHCNBJ92A",
    is_internal_bank: true
  },
  {
    id: 166,
    name: "Bank of China (014)",
    swift_code: "BKCHHKHH",
    is_deleted: false,
    country_id: 3,
    display_name: "Bank of China (014) - BKCHHKHH",
    is_internal_bank: null
  },
  {
    id: 167,
    name: "Bank of China (019)",
    swift_code: "BKCHHKHH",
    is_deleted: false,
    country_id: 3,
    display_name: "Bank of China (019) - BKCHHKHH",
    is_internal_bank: null
  },
  {
    id: 168,
    name: "Bank of China (026)",
    swift_code: "BKCHHKHH",
    is_deleted: false,
    country_id: 3,
    display_name: "Bank of China (026) - BKCHHKHH",
    is_internal_bank: null
  },
  {
    id: 169,
    name: "Bank of China (030)",
    swift_code: "BKCHHKHH",
    is_deleted: false,
    country_id: 3,
    display_name: "Bank of China (030) - BKCHHKHH",
    is_internal_bank: null
  },
  {
    id: 173,
    name: "Bank of China (031)",
    swift_code: "BKCHHKHH",
    is_deleted: false,
    country_id: 3,
    display_name: "Bank of China (031) - BKCHHKHH",
    is_internal_bank: null
  },
  {
    id: 170,
    name: "Bank of China (036)",
    swift_code: "BKCHHKHH",
    is_deleted: false,
    country_id: 3,
    display_name: "Bank of China (036) - BKCHHKHH",
    is_internal_bank: null
  },
  {
    id: 171,
    name: "Bank of China (064)",
    swift_code: "BKCHHKHH",
    is_deleted: false,
    country_id: 3,
    display_name: "Bank of China (064) - BKCHHKHH",
    is_internal_bank: null
  },
  {
    id: 172,
    name: "Bank of China (070)",
    swift_code: "BKCHHKHH",
    is_deleted: false,
    country_id: 3,
    display_name: "Bank of China (070) - BKCHHKHH",
    is_internal_bank: null
  },
  {
    id: 145,
    name: "Bank of China (Hong Kong)",
    swift_code: "BKCHHKHHXXX",
    is_deleted: false,
    country_id: 3,
    display_name: "Bank of China (033) - BKCHHKHH",
    is_internal_bank: null
  },
  {
    id: 120,
    name: "Bank of China (Hong Kong)",
    swift_code: "BKCHHKHHXXX",
    is_deleted: false,
    country_id: 3,
    display_name: "Bank of China (012) - BKCHHKHH",
    is_internal_bank: null
  },
  {
    id: 89,
    name: "BANK OF CHINA (M) BHD",
    swift_code: "BKCHMYKLXXX",
    is_deleted: false,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 222,
    name: "Bank of Communications",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 122,
    name: "Bank of Communications Co., Ltd.",
    swift_code: "COMMHKHHXXX",
    is_deleted: false,
    country_id: 3,
    display_name: "Bank of Communications (027) - COMMHKHH",
    is_internal_bank: null
  },
  {
    id: 121,
    name: "Bank of Communications (Hong Kong) Limited",
    swift_code: "COMMHKHKXXX",
    is_deleted: false,
    country_id: 3,
    display_name: "Bank of Communications, Hong Kong (382) - COMMHKHK",
    is_internal_bank: null
  },
  {
    id: 214,
    name: "Bank of Heritage Isle",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 256,
    name: "Bank of India, Singapore",
    swift_code: "BKIDSGSGXXX",
    is_deleted: false,
    country_id: 1,
    display_name: "BANK OF INDIA, SINGAPORE - BKIDSGSG",
    is_internal_bank: true
  },
  {
    id: 153,
    name: "Bank of Queensland",
    swift_code: "QBANAU4B",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 237,
    name: "Bank of Sydney",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 92,
    name: "BANK SIMPANAN NASIONAL",
    swift_code: "BSNAMYK1XXX",
    is_deleted: false,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 157,
    name: "Bankwest (division of Commonwealth Bank)",
    swift_code: "BKWAAU6P",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 280,
    name: "BANQUE INTERNATIONALE A LUXEMBOURG",
    swift_code: "BILLLULLXXX",
    is_deleted: false,
    country_id: 124,
    display_name: "BANQUE INTERNATIONALE A LUXEMBOURG - BILLLULL",
    is_internal_bank: true
  },
  {
    id: 199,
    name: "B&E",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 290,
    name: "BELFIUS BANQUE SA",
    swift_code: "GKCCBEBBXXX",
    is_deleted: false,
    country_id: 24,
    display_name: "BELFIUS BANQUE SA - GKCCBEBB",
    is_internal_bank: true
  },
  {
    id: 155,
    name: "Bendigo Bank",
    swift_code: "BENDAU3B",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 189,
    name: "Beyond Bank",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 225,
    name: "Big Sky Building Society",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 142,
    name: "BNP Paribas",
    swift_code: "BNPASGSGXXX",
    is_deleted: false,
    country_id: 1,
    display_name: "BNP PARIBAS - BNPASGSG",
    is_internal_bank: null
  },
  {
    id: 287,
    name: "BNP Paribas",
    swift_code: "BNPAHKHH",
    is_deleted: false,
    country_id: 3,
    display_name: "BNP Paribas (056) - BNPAHKHH",
    is_internal_bank: null
  },
  {
    id: 289,
    name: "BNP PARIBAS",
    swift_code: "BNPAFRPPXXX",
    is_deleted: false,
    country_id: 76,
    display_name: "BNP PARIBAS - BNPAFRPP",
    is_internal_bank: true
  },
  {
    id: 35,
    name: "BNP PARIBAS",
    swift_code: "BNPAMYKA",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 93,
    name: "BNP PARIBAS MALAYSIA BERHAD",
    swift_code: "BNPAMYKLXXX",
    is_deleted: false,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 185,
    name: "BNP Paribas Securities",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 240,
    name: "BOQ Specialist",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 36,
    name: "CAGAMAS BERHAD",
    swift_code: "CAGAMYKL",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 218,
    name: "Capricornian",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 124,
    name: "China Citi Bank International Limited",
    swift_code: "KWHKHKHHXXX",
    is_deleted: false,
    country_id: 3,
    display_name: "China Citic Bank International (018) - KWHKHKHH",
    is_internal_bank: null
  },
  {
    id: 228,
    name: "China Construction Bank",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 125,
    name: "China Construction Bank (Asia) Corporation Limited",
    swift_code: "CCBQHKAXXXX",
    is_deleted: false,
    country_id: 3,
    display_name: "China Construction (009) - CCBQHKA",
    is_internal_bank: null
  },
  {
    id: 37,
    name: "CHINA CONSTRUCTION BANK (MALAYSIA) BERHAD",
    swift_code: "PCBCMYKL",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 95,
    name: "CHINA CONSTRUCTION BANK MALAYSIA BERHAD",
    swift_code: "PCBCMYKLXXX",
    is_deleted: false,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 276,
    name: "CHINA MERCHANTS BANK (238)",
    swift_code: "CMBCHKHHXXX",
    is_deleted: false,
    country_id: 3,
    display_name: "CHINA MERCHANTS BANK (238) - CMBCHKHH",
    is_internal_bank: true
  },
  {
    id: 126,
    name: "Chiyu Banking Corporation Limited",
    swift_code: "CIYUHKHHXXX",
    is_deleted: false,
    country_id: 3,
    display_name: "Chiyu Banking (039) - CIYUHKHH",
    is_internal_bank: null
  },
  {
    id: 127,
    name: "Chong Hing Bank Limited",
    swift_code: "LCHBHKHHXXX",
    is_deleted: false,
    country_id: 3,
    display_name: "Chong Hing (041) - LCHBHKHH",
    is_internal_bank: null
  },
  {
    id: 12,
    name: "CIMB",
    swift_code: "CIBBSGSGXXX",
    is_deleted: false,
    country_id: 1,
    display_name: "CIMB - CIBBSGSG",
    is_internal_bank: null
  },
  {
    id: 94,
    name: "CIMB BANK BHD",
    swift_code: "CIBBMYKLXXX",
    is_deleted: false,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 38,
    name: "CIMB BANK (L) LIMITED",
    swift_code: "CIBBMYKA",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 39,
    name: "CIMB-PRINCIPAL ASSET MANAGEMENT BERHAD",
    swift_code: "CANHMYKL",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 184,
    name: "Citibank ",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 40,
    name: "CITIBANK BERHAD",
    swift_code: "CITIMYKLPEN",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 96,
    name: "CITIBANK BHD",
    swift_code: "CITIMYKLXXX",
    is_deleted: false,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 281,
    name: "Citibank Europe plc, France Branch",
    swift_code: "CITIFRPPXXX",
    is_deleted: false,
    country_id: 76,
    display_name: "Citibank Europe plc, France Branch - CITIFRPP",
    is_internal_bank: true
  },
  {
    id: 128,
    name: "Citibank (Hong Kong) Limited",
    swift_code: "CITIHKAXXXX",
    is_deleted: false,
    country_id: 3,
    display_name: "Citibank, Hong Kong (250) - CITIHKA",
    is_internal_bank: null
  },
  {
    id: 190,
    name: "Citibank NA",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 4,
    name: "Citibank N.A.",
    swift_code: "CITISGSGXXX",
    is_deleted: false,
    country_id: 1,
    display_name: "CITIBANK N.A. - CITISGSG",
    is_internal_bank: null
  },
  {
    id: 288,
    name: "Citibank N.A.",
    swift_code: "CITIGB2L",
    is_deleted: false,
    country_id: 3,
    display_name: "Citibank N.A. (108) - CITIGB2L",
    is_internal_bank: null
  },
  {
    id: 129,
    name: "CITIBANK, N.A",
    swift_code: "CITIHKHXXXX",
    is_deleted: false,
    country_id: 3,
    display_name: "Citibank, N.A. (006) - CITIHKH",
    is_internal_bank: null
  },
  {
    id: 117,
    name: "Citibank Singapore Ltd",
    swift_code: "CITISGSLXXX",
    is_deleted: false,
    country_id: 1,
    display_name: "CITIBANK SINGAPORE LTD - CITISGSL",
    is_internal_bank: null
  },
  {
    id: 284,
    name: "Commerzbank AG",
    swift_code: "DRESDEFF513",
    is_deleted: false,
    country_id: 81,
    display_name: "Commerzbank AG - DRESDEFF513",
    is_internal_bank: true
  },
  {
    id: 149,
    name: "Commonwealth Bank of Australia",
    swift_code: "CTBAAU2S",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 192,
    name: "Community First Credit Union",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 282,
    name: "CREDIT AGRICOLE SA",
    swift_code: "AGRIFRPP833",
    is_deleted: false,
    country_id: 76,
    display_name: "CREDIT AGRICOLE SA - AGRIFRPP833",
    is_internal_bank: true
  },
  {
    id: 219,
    name: "Credit Union Australia",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 159,
    name: "Cuscal",
    swift_code: "CUSCAU2S",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 130,
    name: "Dah Sing Bank Limited",
    swift_code: "DSBAHKHHXXX",
    is_deleted: false,
    country_id: 3,
    display_name: "Dah Sing (040) - DSBAHKHH",
    is_internal_bank: null
  },
  {
    id: 1,
    name: "DBS",
    swift_code: "DBSSSGSGXXX",
    is_deleted: false,
    country_id: 1,
    display_name: "DBS - DBSSSGSG",
    is_internal_bank: null
  },
  {
    id: 131,
    name: "DBS Bank (Hong Kong) Limited",
    swift_code: "DHBKHKHHXXX",
    is_deleted: false,
    country_id: 3,
    display_name: "DBS, Hong Kong (016) - DHBKHKHH",
    is_internal_bank: null
  },
  {
    id: 132,
    name: "DBS Bank Ltd, Hong Kong Branch",
    swift_code: "DBSSHKHHXXX",
    is_deleted: false,
    country_id: 3,
    display_name: "DBS (185) - DBSSHKHH",
    is_internal_bank: null
  },
  {
    id: 41,
    name: "DBS BANK LTD, LABUAN BRANCH",
    swift_code: "DBSSMY2A",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 226,
    name: "Defence Bank",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 236,
    name: "Delphi Bank (division of Bendigo and Adelaide Bank)",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 20,
    name: "Deutsche Bank",
    swift_code: "DEUTSGSGXXX",
    is_deleted: false,
    country_id: 1,
    display_name: "DEUTSCHE BANK - DEUTSGSG",
    is_internal_bank: null
  },
  {
    id: 286,
    name: "Deutsche Bank AG",
    swift_code: "DEUTHKHH",
    is_deleted: false,
    country_id: 3,
    display_name: "Deutsche Bank (054) - DEUTHKHH",
    is_internal_bank: null
  },
  {
    id: 42,
    name: "DEUTSCHE BANK (MALAYSIA) BERHAD",
    swift_code: "DEUTMYKL",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 97,
    name: "DEUTSCHE BANK (M) BHD",
    swift_code: "DEUTMYKLXXX",
    is_deleted: false,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 198,
    name: "Endeavour Mutual Bank",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 262,
    name: "E. Sun Commercial Bank Ltd",
    swift_code: "ESUNTWTPXXX",
    is_deleted: false,
    country_id: 211,
    display_name: "E. Sun Commercial Bank Ltd - ESUNTWTP",
    is_internal_bank: true
  },
  {
    id: 43,
    name: "EXPORT-IMPORT BANK OF MALAYSIA BERHAD",
    swift_code: "EXMBMYKL",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 16,
    name: "Far Eastern Bank",
    swift_code: "UOVBSGSGXXX",
    is_deleted: true,
    country_id: 1,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 248,
    name: "FAZZ (Xfers Pte Ltd)",
    swift_code: "XFEPSGSGXXX",
    is_deleted: false,
    country_id: 1,
    display_name: "FAZZ - XFEPSGSG",
    is_internal_bank: null
  },
  {
    id: 44,
    name: "FELDA GLOBAL VENTURES CAPITAL SDN. BHD.",
    swift_code: "FGVCMYKL",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 45,
    name: "FIDELITY ASIA BANK LTD",
    swift_code: "FABEMY22",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 46,
    name: "FIRST EAST EXPORT BANK",
    swift_code: "FEEBMYKA",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 143,
    name: "FUBON BANK (HONG KONG) LIMITED (128)",
    swift_code: "IBALHKHHXXX",
    is_deleted: false,
    country_id: 3,
    display_name: "FUBON BANK (HONG KONG) LIMITED (128) - IBALHKHH",
    is_internal_bank: null
  },
  {
    id: 211,
    name: "Gateway Bank",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 210,
    name: "G&C Mutual Bank",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 186,
    name: "Greater Bank",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 133,
    name: "Hang Seng Bank, Limited",
    swift_code: "HASEHKHHXXX",
    is_deleted: false,
    country_id: 3,
    display_name: "Hang Seng (024) - HASEHKHH",
    is_internal_bank: null
  },
  {
    id: 201,
    name: "Heritage Bank",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 114,
    name: "HL Bank",
    swift_code: "HLBBSGSGXXX",
    is_deleted: false,
    country_id: 1,
    display_name: "HL BANK - HLBBSGSG",
    is_internal_bank: null
  },
  {
    id: 212,
    name: "Holiday Coast Credit Union",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 202,
    name: "Home Building Society (division of Bank of Queensland)",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 98,
    name: "HONGKONG BANK MALAYSIA BHD-HSBC",
    swift_code: "HBMBMYKLXXX",
    is_deleted: false,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 47,
    name: "HONG LEONG BANK BERHAD",
    swift_code: "HLBBMYKL",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 111,
    name: "HONG LEONG BANK BHD",
    swift_code: "HLBBMYKLXXX",
    is_deleted: false,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 162,
    name: "HSBC",
    swift_code: "HKBAAU2S",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 242,
    name: "HSBC Bank Australia",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 279,
    name: "HSBC BANK PLC",
    swift_code: "MIDLGB22XXX",
    is_deleted: false,
    country_id: 228,
    display_name: "HSBC BANK PLC - MIDLGB22",
    is_internal_bank: true
  },
  {
    id: 5,
    name: "HSBC Bank Singapore Ltd ",
    swift_code: "HSBCSGS2XXX",
    is_deleted: false,
    country_id: 1,
    display_name: "HSBC BANK SINGAPORE LTD - HSBCSGS2",
    is_internal_bank: null
  },
  {
    id: 22,
    name: "HSBC Corporation Ltd",
    swift_code: "HSBCSGSGXXX",
    is_deleted: false,
    country_id: 1,
    display_name: "HSBC CORPORATION LTD - HSBCSGSG",
    is_internal_bank: null
  },
  {
    id: 48,
    name: "HSBC (MALAYSIA) TRUSTEE BERHAD",
    swift_code: "HSTMMYKL",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 203,
    name: "Hume Bank",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 49,
    name: "IBH INVESTMENT BANK LIMITED",
    swift_code: "IBHIMY2L",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 9,
    name: "ICICI Bank",
    swift_code: "ICICSGSGXXX",
    is_deleted: true,
    country_id: 1,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 204,
    name: "IMB",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 99,
    name: "IND&COMM BANK OF CHINA (M) BHD",
    swift_code: "ICBKMYKLXXX",
    is_deleted: false,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 50,
    name: "INDIA INTERNATIONAL BANK (MALAYSIA) BERHAD",
    swift_code: "IIMBMYKL",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 15,
    name: "Indian Overseas Bank",
    swift_code: "IOBASGSGXXX",
    is_deleted: true,
    country_id: 1,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 135,
    name: "Industrial and Commercial Bank of China (Asia) Limited",
    swift_code: "UBHKHKHHXXX",
    is_deleted: false,
    country_id: 3,
    display_name: "Industrial and Commercial Bank of China (072) - UBHKHKHH",
    is_internal_bank: null
  },
  {
    id: 51,
    name: "INDUSTRIAL AND COMMERCIAL BANK OF CHINA (MALAYSIA) BERHAD.",
    swift_code: "ICBKMYKL",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 146,
    name: "Industrial & Commercial Bank",
    swift_code: "ICBKSGSGXXX",
    is_deleted: false,
    country_id: 1,
    display_name: "INDUSTRIAL & COMMERCIAL BANK - ICBKSGSG",
    is_internal_bank: null
  },
  {
    id: 223,
    name: "Industrial & Commercial Bank of China",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 163,
    name: "ING",
    swift_code: "INGBAU2S",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 235,
    name: "ING Bank",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 183,
    name: "JP Morgan Chase Bank",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 255,
    name: "JPMorgan Chase Bank",
    swift_code: "CHASSGSGXXX",
    is_deleted: false,
    country_id: 1,
    display_name: "JPMORGAN CHASE BANK - CHASSGSG",
    is_internal_bank: true
  },
  {
    id: 52,
    name: "J.P.MORGAN CHASE BANK BERHAD",
    swift_code: "CHASMYKX",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 100,
    name: "J.P. MORGAN CHASE BANK BHD",
    swift_code: "CHASMYKXXXX",
    is_deleted: false,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 53,
    name: "JPMORGAN CHASE BANK, N.A., LABUAN BRANCH",
    swift_code: "CHASMY2A",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 246,
    name: "JP Morgan Chase NA HK Branch",
    swift_code: "CHASHKHHXXX",
    is_deleted: false,
    country_id: 3,
    display_name: "JP Morgan Chase NA HK Branch (007) - CHASHKHH",
    is_internal_bank: null
  },
  {
    id: 268,
    name: "JP MORGAN CHASE NEW YORK",
    swift_code: "CHASUS33XXX",
    is_deleted: false,
    country_id: 229,
    display_name: "JP MORGAN CHASE NEW YORK - CHASUS33",
    is_internal_bank: true
  },
  {
    id: 54,
    name: "KAF INVESTMENT BANK BERHAD",
    swift_code: "KAFBMYKL",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 266,
    name: "KEB HANA BANK",
    swift_code: "KOEXKRSEXXX",
    is_deleted: false,
    country_id: 200,
    display_name: "KEB HANA BANK - KOEXKRSE",
    is_internal_bank: true
  },
  {
    id: 55,
    name: "KENANGA INVESTMENT BANK BERHAD",
    swift_code: "ECMLMYKL",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 101,
    name: "KUWAIT FINANCE HOUSE",
    swift_code: "KFHOMYKLXXX",
    is_deleted: false,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 56,
    name: "KUWAIT FINANCE HOUSE (MALAYSIA) BERHAD",
    swift_code: "KFHOMYKL",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 244,
    name: "LIVI BANK LIMITED",
    swift_code: "LIVIHKHHXXX",
    is_deleted: false,
    country_id: 3,
    display_name: "LIVI BANK LIMITED (388) - LIVIHKHH",
    is_internal_bank: null
  },
  {
    id: 154,
    name: "Macquarie Bank",
    swift_code: "MACQAU2S",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 207,
    name: "Maitland Mutual Building Society",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 8,
    name: "Malayan Banking Berhad",
    swift_code: "MBBESGSGXXX",
    is_deleted: false,
    country_id: 1,
    display_name: "MALAYAN BANKING BERHAD - MBBESGSG",
    is_internal_bank: null
  },
  {
    id: 57,
    name: "MALAYAN BANKING BERHAD (MAYBANK)",
    swift_code: "MBBEMYKLBWC",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 253,
    name: "MARIBANK SINGAPORE PRIVATE LIMITED",
    swift_code: "SSPISGSGXXX",
    is_deleted: false,
    country_id: 1,
    display_name: "MARIBANK SINGAPORE PRIVATE LIMITED - SSPISGSG",
    is_internal_bank: null
  },
  {
    id: 274,
    name: "MATCHMOVE PAY PTE LTD",
    swift_code: "MAYPSGSGXXX",
    is_deleted: false,
    country_id: 1,
    display_name: "MATCHMOVE PAY PTE LTD - MAYPSGSG",
    is_internal_bank: true
  },
  {
    id: 58,
    name: "MAX MONEY SDN BHD",
    swift_code: "MMSBMYKL",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 102,
    name: "MAYBANK BERHAD",
    swift_code: "MBBEMYKLXXX",
    is_deleted: false,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 59,
    name: "MAYBANK INTERNATIONAL (L) LTD.",
    swift_code: "MBBEMYKA",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 115,
    name: "Maybank Singapore Limited",
    swift_code: "MBBESGS2XXX",
    is_deleted: false,
    country_id: 1,
    display_name: "MAYBANK SINGAPORE LIMITED – MBBESGS2",
    is_internal_bank: null
  },
  {
    id: 112,
    name: "MBSB BANK BERHAD",
    swift_code: "AFBQMYKLXXX",
    is_deleted: false,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 233,
    name: "Mega International Commercial Bank",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 60,
    name: "MEGA INTERNATIONAL COMMERCIAL BANK CO., LTD. LABUAN BRANCH",
    swift_code: "ICBCMY2L",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 160,
    name: "Members Equity (ME) Bank",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 61,
    name: "MERCEDES-BENZ MALAYSIA SDN. BHD.",
    swift_code: "DABEMYKL",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 62,
    name: "MIDDLE EAST INVESTMENT BANK LTD",
    swift_code: "MEIBMYKA",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 17,
    name: "Mizuho Bank",
    swift_code: "MHCBSGSGXXX",
    is_deleted: false,
    country_id: 1,
    display_name: "MIZUHO BANK - MHCBSGSG",
    is_internal_bank: null
  },
  {
    id: 258,
    name: "Mizuho Bank, ltd. Hong Kong Branch",
    swift_code: "MHCBHKHHXXX",
    is_deleted: false,
    country_id: 3,
    display_name: "Mizuho Bank, ltd. Hong Kong Branch (109) - MHCBHKHH",
    is_internal_bank: true
  },
  {
    id: 257,
    name: "Mizuho Bank, ltd. Hong Kong Branch",
    swift_code: "MHCBHKHHXXX",
    is_deleted: false,
    country_id: 1,
    display_name: "MIZUHO BANK, LTD. HONG KONG BRANCH - MHCBHKHH",
    is_internal_bank: true
  },
  {
    id: 63,
    name: "MIZUHO BANK (MALAYSIA) BERHAD",
    swift_code: "MHCBMYKA",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 103,
    name: "MIZUHO BANK (M) BERHAD",
    swift_code: "MHCBMYKAXXX",
    is_deleted: false,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 215,
    name: "MOVE",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 187,
    name: "MUFG Bank",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 141,
    name: "MUFG BANK - BOTKSGSX",
    swift_code: "BOTKSGSXXXX",
    is_deleted: false,
    country_id: 1,
    display_name: "MUFG BANK – BOTKSGSX",
    is_internal_bank: null
  },
  {
    id: 285,
    name: "MUFG Bank, Ltd.",
    swift_code: "BOTKHKHH",
    is_deleted: false,
    country_id: 3,
    display_name: "MUFG Bank (047) - BOTKHKHH",
    is_internal_bank: null
  },
  {
    id: 90,
    name: "MUFG BANK MALAYSIA BERHAD (BTMU)",
    swift_code: "BOTKMYKXXXX",
    is_deleted: false,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 110,
    name: "MUFG BANK MALAYSIA BERHAD - SPI (IBOT)",
    swift_code: "BOTKMYKXXXX",
    is_deleted: false,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 188,
    name: "#N/A",
    swift_code: "none",
    is_deleted: true,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 136,
    name: "Nanyang Commercial Bank Limited",
    swift_code: "NYCBHKHHXXX",
    is_deleted: false,
    country_id: 3,
    display_name: "Nanyang Commercial (043) - NYCBHKHH",
    is_internal_bank: null
  },
  {
    id: 152,
    name: "National Australia Bank",
    swift_code: "NATAAU3303M",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 64,
    name: "NATIONAL BANK OF ABU DHABI",
    swift_code: "NBADMYKL",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 179,
    name: "Newcastle Permanent Building Society",
    swift_code: "NPBOAU21",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 65,
    name: "NOMURA ASSET MANAGEMENT MALAYSIA SDN BHD",
    swift_code: "NOCMMYKL",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 2,
    name: "OCBC",
    swift_code: "OCBCSGSGXXX",
    is_deleted: false,
    country_id: 1,
    display_name: "OCBC - OCBCSGSG",
    is_internal_bank: null
  },
  {
    id: 66,
    name: "OCBC AL-AMIN BANK BERHAD",
    swift_code: "OABBMYKL",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 191,
    name: "OCBC Bank",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 104,
    name: "OCBC BANK (M) BHD",
    swift_code: "OCBCMYKLXXX",
    is_deleted: false,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 137,
    name: "OCBC Wing Hang Bank Limited",
    swift_code: "WIHBHKHHXXX",
    is_deleted: false,
    country_id: 3,
    display_name: "OCBC Wing Hang (035) - WIHBHKHH",
    is_internal_bank: null
  },
  {
    id: 67,
    name: "OVERSEA-CHINESE BANKING CORP. LTD, LABUAN BRANCH",
    swift_code: "OCBCMYKA",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 68,
    name: "PETROLIAM NASIONAL BERHAD",
    swift_code: "PTROMYKL",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 69,
    name: "PG ASIA INVESTMENT BANK LTD",
    swift_code: "AINEMY22",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 14,
    name: "Philippine National Bank",
    swift_code: "PNBMSGSGXXX",
    is_deleted: true,
    country_id: 1,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 208,
    name: "Pioneer Permanent Building Society (division of Bank of Queensland)",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 220,
    name: "Police Bank",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 217,
    name: "Police & Nurse",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 19,
    name: "POSB",
    swift_code: "DBSSSGSGXXX",
    is_deleted: false,
    country_id: 1,
    display_name: "POSB - DBSSSGSG",
    is_internal_bank: null
  },
  {
    id: 70,
    name: "POS MALAYSIA BERHAD",
    swift_code: "POSMMYKL",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 263,
    name: "Pt Bank Uob Indonesia",
    swift_code: "BBIJIDJAXXX",
    is_deleted: false,
    country_id: 98,
    display_name: "Pt Bank Uob Indonesia - BBIJIDJA",
    is_internal_bank: true
  },
  {
    id: 259,
    name: "PUBLIC BANK BERHARD",
    swift_code: "PBBEMYKL",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 105,
    name: "PUBLIC BANK BHD",
    swift_code: "PBBEMYKLXXX",
    is_deleted: false,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 148,
    name: "Public Bank (Hong Kong) Limited",
    swift_code: "CBHKHKHH",
    is_deleted: false,
    country_id: 3,
    display_name: "Public Bank (Hong Kong) Limited (028) - CBHKHKHH",
    is_internal_bank: null
  },
  {
    id: 71,
    name: "PUBLIC BANK (L) LTD",
    swift_code: "PBLLMYKA",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 247,
    name: "PUBLIC ISLAMIC BANK BERHARD",
    swift_code: "PIBEMYK1XXX",
    is_deleted: false,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 164,
    name: "Qudos Banks",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 161,
    name: "Queensland Country Bank",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 181,
    name: "Rabobank",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 193,
    name: "RACQ Bank",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 234,
    name: "Regional Australia Bank",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 178,
    name: "Reserve Bank of Australia",
    swift_code: "RSBKAU2SXXX",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 13,
    name: "RHB",
    swift_code: "RHBBSGSGXXX",
    is_deleted: false,
    country_id: 1,
    display_name: "RHB - RHBBSGSG",
    is_internal_bank: null
  },
  {
    id: 106,
    name: "RHB BANK BHD",
    swift_code: "RHBBMYKLXXX",
    is_deleted: false,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 72,
    name: "RHB BANK (L) LTD",
    swift_code: "RHBBMYKA",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 73,
    name: "RHB INVESTMENT BANK BERHAD",
    swift_code: "OSKIMYKL",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 291,
    name: "Santander Corporate & Commercial",
    swift_code: "ABBYGB2LXXX",
    is_deleted: false,
    country_id: 228,
    display_name: "Santander Corporate & Commercial - ABBYGB2L",
    is_internal_bank: true
  },
  {
    id: 138,
    name: "Shanghai Commercial Bank Limited",
    swift_code: "SCBKHKHHXXX",
    is_deleted: false,
    country_id: 3,
    display_name: "Shanghai Commercial (025) - SCBKHKHH",
    is_internal_bank: null
  },
  {
    id: 261,
    name: "Shinhan Bank(China) Ltd",
    swift_code: "SHBKCNBJXXX",
    is_deleted: false,
    country_id: 47,
    display_name: "Shinhan Bank(China) Ltd - SHBKCNBJ",
    is_internal_bank: true
  },
  {
    id: 213,
    name: "Southern Cross Credit Union",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 10,
    name: "Standard Chartered Bank",
    swift_code: "SCBLSGSGXXX",
    is_deleted: true,
    country_id: 1,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 107,
    name: "STANDARD CHARTERED BANK BHD",
    swift_code: "SCBLMYKXXXX",
    is_deleted: false,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 139,
    name: "Standard Chartered Bank (Hong Kong) Limited",
    swift_code: "SCBLHKHHXXX",
    is_deleted: false,
    country_id: 3,
    display_name: "Standard Chartered (003) - SCBLHKHH",
    is_internal_bank: null
  },
  {
    id: 74,
    name: "STANDARD CHARTERED BANK MALAYSIA BERHAD",
    swift_code: "SCBLMYKX",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 119,
    name: "Standard Chartered Bank (Singapore) Ltd",
    swift_code: "SCBLSG22XXX",
    is_deleted: false,
    country_id: 1,
    display_name: "STANDARD CHARTERED BANK (SINGAPORE) LTD - SCBLSG22",
    is_internal_bank: null
  },
  {
    id: 11,
    name: "State Bank of India",
    swift_code: "SBINSGSGXXX",
    is_deleted: true,
    country_id: 1,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 249,
    name: "STATE BANK OF INDIA",
    swift_code: "SBINSGSGXXX",
    is_deleted: false,
    country_id: 1,
    display_name: "STATE BANK OF INDIA - SBINSGSG",
    is_internal_bank: null
  },
  {
    id: 230,
    name: "State Street Bank & Trust Company",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 108,
    name: "SUMITOMO MITSUI BANK",
    swift_code: "SMBCMYKLXXX",
    is_deleted: false,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 116,
    name: "Sumitomo Mitsui Banking Corporation",
    swift_code: "SMBCSGSGXXX",
    is_deleted: false,
    country_id: 1,
    display_name: "SUMITOMO MITSUI BANKING CORPORATION - SMBCSGSG",
    is_internal_bank: null
  },
  {
    id: 75,
    name: "SUMITOMO MITSUI BANKING CORPORATION",
    swift_code: "SMBCMYKA",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 270,
    name: "SUMITOMO MITSUI BANKING CORPORATION",
    swift_code: "SMBCJPJTXXX",
    is_deleted: false,
    country_id: 107,
    display_name: "SUMITOMO MITSUI BANKING CORPORATION - SMBCJPJT",
    is_internal_bank: true
  },
  {
    id: 174,
    name: "Sumitomo Mitsui Banking Corporation (065)",
    swift_code: "SMBCHKHHXXX",
    is_deleted: false,
    country_id: 3,
    display_name: "Sumitomo Mitsui Banking Corporation (065) - SMBCHKHH",
    is_internal_bank: null
  },
  {
    id: 175,
    name: "Sumitomo Mitsui Trust Bank (371)",
    swift_code: "STBCHKHHXXX",
    is_deleted: false,
    country_id: 3,
    display_name: "Sumitomo Mitsui Trust Bank (371) - STBCHKHH",
    is_internal_bank: null
  },
  {
    id: 216,
    name: "Summerland Credit Union",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 158,
    name: "Suncorp-Metway",
    swift_code: "METWAU4B",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 224,
    name: "Sutherland Credit Union",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 144,
    name: "TAIPEI FUBON COMMERCIAL BANK (HONG KONG) LIMITED (239)",
    swift_code: "TPBKHKHHXXX",
    is_deleted: false,
    country_id: 3,
    display_name:
      "TAIPEI FUBON COMMERCIAL BANK (HONG KONG) LIMITED (239) - TPBKHKHH",
    is_internal_bank: null
  },
  {
    id: 238,
    name: "Taiwan Business Bank",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 18,
    name: "The Bank of East Asia",
    swift_code: "BEASSGSGXXX",
    is_deleted: true,
    country_id: 1,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 123,
    name: "The Bank of East Asia, Limited",
    swift_code: "BEASHKHHXXX",
    is_deleted: false,
    country_id: 3,
    display_name: "Bank of East Asia (015) - BEASHKHH",
    is_internal_bank: null
  },
  {
    id: 76,
    name: "THE BANK OF NOVA SCOTIA BERHAD",
    swift_code: "NOSCMYKL",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 134,
    name: "The Hongkong and Shanghai Banking Corporation Limited",
    swift_code: "HSBCHKHHHKH",
    is_deleted: false,
    country_id: 3,
    display_name: "Hong Kong and Shanghai (HSBC) (004) - HSBCHKHHHKH",
    is_internal_bank: null
  },
  {
    id: 77,
    name: "THE HONGKONG AND SHANGHAI BANKING CORPORATION LIMITED",
    swift_code: "HSBCMYKA",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 209,
    name: "The Rock",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 78,
    name: "TMC SERVICES SDN. BHD.",
    swift_code: "TMCBMYKL",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 271,
    name: "TORONTO DOMINION BANK",
    swift_code: "TDOMCATTTOR",
    is_deleted: false,
    country_id: 41,
    display_name: "TORONTO DOMINION BANK - TDOMCATTTOR",
    is_internal_bank: true
  },
  {
    id: 182,
    name: "Town & Country Bank",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 177,
    name: "TransferWise Singapore Pte Ltd",
    swift_code: "TRWISGSGXXX",
    is_deleted: false,
    country_id: 1,
    display_name: "TRANSFERWISE - TRWISGSG",
    is_internal_bank: null
  },
  {
    id: 243,
    name: "TRUST BANK SINGAPORE LIMITED",
    swift_code: "TRBUSGSGXXX",
    is_deleted: false,
    country_id: 1,
    display_name: "TRUST BANK SINGAPORE LIMITED - TRBUSGSG",
    is_internal_bank: null
  },
  {
    id: 241,
    name: "Tyro Payments",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 239,
    name: "UBS AG",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 283,
    name: "UNICREDIT BANK",
    swift_code: "HYVEDEMMXXX",
    is_deleted: false,
    country_id: 81,
    display_name: "UNICREDIT BANK - HYVEDEMM",
    is_internal_bank: true
  },
  {
    id: 232,
    name: "United Overseas Bank",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 176,
    name: "UNITED OVERSEAS BANK LTD HONG KONG (071)",
    swift_code: "UOVBHKHHXXX",
    is_deleted: false,
    country_id: 3,
    display_name: "UNITED OVERSEAS BANK LTD HONG KONG (071) - UOVBHKHH",
    is_internal_bank: null
  },
  {
    id: 79,
    name: "UNITED OVERSEAS BANK (MALAYSIA) BERHAD",
    swift_code: "UOVBMYKL",
    is_deleted: true,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 113,
    name: "UNITED OVERSEAS BANK MALAYSIA BHD",
    swift_code: "UOVBMYKLXXX",
    is_deleted: false,
    country_id: 2,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 200,
    name: "Uniting Financial Services",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 227,
    name: "Unity Bank",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 7,
    name: "UOB",
    swift_code: "UOVBSGSGXXX",
    is_deleted: false,
    country_id: 1,
    display_name: "UOB - UOVBSGSG",
    is_internal_bank: null
  },
  {
    id: 278,
    name: "US BANK",
    swift_code: "USBKUS44IMT",
    is_deleted: false,
    country_id: 229,
    display_name: "US BANK - USBKUS44IMT",
    is_internal_bank: true
  },
  {
    id: 267,
    name: "US BANK",
    swift_code: "USBKUS44XXX",
    is_deleted: false,
    country_id: 229,
    display_name: "US BANK - USBKUS44",
    is_internal_bank: true
  },
  {
    id: 194,
    name: "Volt Bank",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 221,
    name: "Warwick Credit Union",
    swift_code: "none",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 273,
    name: "WELLS FARGO BANK",
    swift_code: "WFBIUS6SXXX",
    is_deleted: false,
    country_id: 229,
    display_name: "WELLS FARGO BANK - WFBIUS6S",
    is_internal_bank: true
  },
  {
    id: 150,
    name: "Westpac Banking Corporation",
    swift_code: "WPACAU2S",
    is_deleted: false,
    country_id: 16,
    display_name: null,
    is_internal_bank: null
  },
  {
    id: 277,
    name: "Wiesbadener Volksbank",
    swift_code: "WIBADE5WXXX",
    is_deleted: false,
    country_id: 81,
    display_name: "Wiesbadener Volksbank - WIBADE5W",
    is_internal_bank: true
  },
  {
    id: 140,
    name: "Wing Lung Bank Limited",
    swift_code: "WUBAHKHHXXX",
    is_deleted: false,
    country_id: 3,
    display_name: "Wing Lung (020) - WUBAHKHH",
    is_internal_bank: null
  },
  {
    id: 147,
    name: "Yuanta Bank (378)",
    swift_code: "OURBHKHHXXX",
    is_deleted: false,
    country_id: 3,
    display_name: "Yuanta Bank (378) - OURBHKHH",
    is_internal_bank: null
  }
];
export default t;
